import { createStandardAction } from 'typesafe-actions';

const startWizardSession = createStandardAction('WIZARD_SESSION/START')();

export { startWizardSession };
